import * as reactTemplater from '@bit/bit.javascript.template.react';
import * as vueTemplater from '@bit/bit.javascript.template.vue';
import { makeAngularTemplate, mainFile as angularMainFile } from '@bit/bit.javascript.template.angular';
import { makeReactNativeTemplate, mainFile as reactNativeMainFile} from '@bit/bit.javascript.template.react-native'

import { createRemote, CapsuleType } from '@bit/amit.capsule-dev.remote-capsule';
import { Router } from '../capsule';

const router = new Router();

router.register([
	{
		name: CapsuleType.react,
		factory: createRemote,
		generateDefaultCode: reactTemplater.makeTemplate,
		mainFile: reactTemplater.mainFile,
		wrkDir: '/capsule/src/App',
		logoUrl: '/img/logo-react.svg',
		hmrEnabled: true,
	},
	{
		name: CapsuleType.vue,
		factory: createRemote,
		generateDefaultCode: vueTemplater.makeTemplate,
		mainFile: vueTemplater.mainFile,
		wrkDir: '/capsule/src/components',
		logoUrl: '/img/logo-vue.svg',
		hmrEnabled: true,
	},
	{
		name: CapsuleType.angular,
		factory: createRemote,
		generateDefaultCode: makeAngularTemplate,
		mainFile: angularMainFile,
		wrkDir: '/capsule/src/app',
		logoUrl: '/img/logo-angular.svg',
		hmrEnabled: true,
	},
	{
		name: CapsuleType.node,
		factory: createRemote,
		generateDefaultCode: makeAngularTemplate,
		mainFile: 'index.js',
		wrkDir: '/capsule',
		logoUrl: '/img/logo-node.svg',
		hmrEnabled: false,
	},
	{
		name: CapsuleType.react_native,
		factory: createRemote,
		generateDefaultCode: makeReactNativeTemplate,
		mainFile: reactNativeMainFile,
		wrkDir: '/capsule/src/App',
		logoUrl: '/img/logo-react-native.svg',
		hmrEnabled: true
	}
]);

export { router };
